import React, { useEffect, useRef, useState } from "react";

import { Container } from "react-bootstrap";

import type { ChangeEvent, KeyboardEvent } from "react";

interface IPinCodeInputProps {
  onComplete: (pin: string) => void;
}

const PinCodeComponent: React.FC<IPinCodeInputProps> = ({ onComplete }) => {
  const [pin, setPin] = useState<string[]>(["", "", "", ""]);
  const inputRefs = [
    useRef<HTMLInputElement>(null),
    useRef<HTMLInputElement>(null),
    useRef<HTMLInputElement>(null),
    useRef<HTMLInputElement>(null),
  ];

  useEffect(() => {
    if (pin.every((value) => value !== "")) {
      onComplete(pin.join(""));
    }
  }, [pin, onComplete]);

  const handleInputChange = (
    event: ChangeEvent<HTMLInputElement>,
    index: number,
  ) => {
    const { value } = event.target;
    if (/^\d*$/.test(value) && value.length <= 1) {
      const newPin = [...pin];
      newPin[index] = value;
      setPin(newPin);

      if (value !== "" && index < 3) {
        inputRefs[index + 1].current?.focus();
      }
    }
  };

  const handleInputKeyDown = (
    event: KeyboardEvent<HTMLInputElement>,
    index: number,
  ) => {
    if (event.key === "Backspace" && index > 0 && pin[index] === "") {
      inputRefs[index - 1].current?.focus();
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Container>
        <div className="pinCodeContainer">
          {pin.map((digit, index) => (
            <input
              key={index}
              ref={inputRefs[index]}
              className="pinCode"
              maxLength={1}
              onChange={(e) => handleInputChange(e, index)}
              onKeyDown={(e) => handleInputKeyDown(e, index)}
              type="tel"
              value={digit}
            />
          ))}
        </div>
      </Container>
    </div>
  );
};

export default PinCodeComponent;
